let it = {
  translations: {
    home: {
      installer: "Installatore",
      support: "Supporto",
      customer: "Cliente",
      admin: "Admin",
    },
    login: {
      title: "Accedi",
      username: "Username",
      password: "Password",
      button: "Accedi",
      have_account: "Hai un account? ",
      sign_in: "Accedi",
      swipe_text: "Scorri per sbloccare",
      swipe_text_unlocked: "Sbloccato",
      errors: {
        user_required: "Campo email obbligatorio",
        password_required: "Campo password obbligatorio",
      },
    },
    reset: {
      title: "Reset Password",
      email: "Email",
      username: "Username",
      button: "Invia link di reset",
      dont_remember_password: "Hai dimenticato la password? ",
      reset: "Reset",
      text: "Inserire la username associata al tuo account, a cui sarà inviato il link di reset della tua password.",
      message:
        "Un link di reset della tua password sarà inviato alla tua email.",
      username_does_not_exist: "Username inesistente",
    },
    reset_confirm: {
      title: "Reset Password",
      password: "Password",
      confirm_password: "Conferma Password",
      button: "Reset password",
      text: "",
      message: "Bentornato! La password è stata aggiornata.",
      errors: {
        password_mismatch: "le password non coincidono",
        wrong_password: "password errata",
      },
    },
    register: {
      tabs: {
        installer: "Installatore",
        customer: "Cliente",
      },
      title: "Crea account",
      first_name: "Nome",
      last_name: "Cognome",
      email: "Email",
      username: "Username",
      password: "Password",
      confirm_password: "Conferma Password",
      telephone_number: "Telefono",
      cellular_number: "Cellulare",
      fax_number: "Fax",
      street: "Via",
      city: "Città",
      cap: "Cap",
      district: "Provincia",
      country: "Paese",
      vat_number: "Vat",
      button: "Registrati",
      address_title: "Indirizzo",
      password_title: "Password",
      contact_title: "Contatto",
      account_title: "Account",
      profile_title: "Profilo",
      dont_have_account: "Non hai un account? ",
      sign_up: "Iscriviti",
      title_edit_address: "Modifica Indirizzo",
      title_edit_profile: "Modifica Profilo",
      title_edit_contacts: "Modifica Contatti",
      terms_and_conditions: "Accetto il contratto di vendita di Eklok",
      terms_and_conditions_link:
        "https://www.ecat.it/src/html/doc/contratto_eklok_ita.pdf",
      button_save: "Salva",
      errors: {
        required: "Campo obbligatorio",
        invalid_email: "Email non valida",
      },
      success: {
        title: "Successo",
        message: "Congratulazioni, il tuo account è stato creato con successo!",
      },
    },
    support: {
      create_support: "Crea Profilo Supporto",
    },
    profile: {
      change_password: {
        title: "Modificare Password",
        current_password: "Password Corrente",
        new_password: "Nuova Password",
        confirm_password: "Conferma Password",
        button: "Salva",
        errors: {
          password_mismatch: "password mismatch",
          wrong_password: "wrong password",
        },
      },
      update: "AGGIORNA",
    },
    installations: {
      add: "Aggiungi Plant",
    },
    nav_menu: {
      home: "HOME",
      link_home: "https://www.ecat.it/",
      reserved_area: "AREA RISERVATA",
      link_reserved_area: "https://www.ecat.it/area-riservata/",
      products: "PRODOTTI",
      link_products: "https://www.ecat.it/prodotti/",
      gallery: "GALLERY",
      link_gallery: "https://www.ecat.it/gallery/",
      support: "ASSISTENZA",
      link_support: "https://www.ecat.it/assistenza/",
      contact_us: "CONTATTACI",
      link_contact_us: "https://www.ecat.it/contatti/",
    },
    nav_menuburger: {
      home: "Home",
      link_home: "https://www.ecat.it/",
      reserved_area: "Area riservata",
      link_reserved_area: "https://www.ecat.it/area-riservata/",
      products: "Prodotti",
      link_products: "https://www.ecat.it/prodotti/",
      gallery: "Gallery",
      link_gallery: "https://www.ecat.it/gallery/",
      support: "Assistenza",
      link_support: "https://www.ecat.it/assistenza/",
      contact_us: "Contattaci",
      link_contact_us: "https://www.ecat.it/contatti/",
    },
    detail_customer: {
      edit_profile: "Modifica Profilo",
      edit_address: "Modifica Indirizzo",
      edit_contacts: "Modifica Contatti",
      delete_profile: "Elimina Customer",
      address: {
        country: "Paese",
        district: "Provincia",
        city: "Città",
        street: "Via",
        cap: "Cap",
      },
      contacts: {
        mobile_phone: "Cellulare",
        telephone: "Telefono",
        vat_number: "Partita Iva",
      },
      user: {
        first_name: "Nome",
        last_name: "Cognome",
        email: "Email",
      },
    },
    delete_customer: {
      title: "Elimina Customer",
      text: "Sei sicuro di voler eliminare questo customer?",
      button_text: "Conferma",
      success_text: "Il customer è stato eliminato con successo",
    },
    detail_support: {
      edit_profile: "Edit Profile",
      edit_address: "Edit Address",
      edit_contacts: "Edit Contacts",
      delete_profile: "Delete support",
      address: {
        country: "Country",
        district: "District",
        city: "City",
        street: "Street",
        cap: "Cap",
      },
      contacts: {
        mobile_phone: "Mobile Phone",
        telephone: "Telephone",
        vat_number: "Vat Number",
      },
      user: {
        first_name: "First Name",
        last_name: "Last Name",
        email: "Email",
      },
    },
    delete_support: {
      title: "Elimina supporto",
      text: "Sei sicuro di voler eliminare questo supporto?",
      button_text: "Conferma",
      success_text: "Il supporto è stato eliminato con successo",
    },
    detail_installer: {
      edit_profile: "Modifica Profilo",
      edit_address: "Modifica Indirizzo",
      edit_contacts: "Modifica Contatti",
      delete_profile: "Elimina Installer",
      address: {
        country: "Paese",
        district: "Provincia",
        city: "Città",
        street: "Via",
        cap: "Cap",
      },
      contacts: {
        mobile_phone: "Cellulare",
        telephone: "Telefono",
        vat_number: "Partita iva",
      },
      user: {
        first_name: "Nome",
        last_name: "Cognome",
        email: "Email",
        id_installer: "ID Installer",
      },
    },
    delete_installer: {
      title: "Elimina Installer",
      text: "Sei sicuro di voler eliminare questo installer?",
      button_text: "Conferma",
      success_text: "L'installer è stato eliminato con successo",
    },
    customer_card: {
      title: "CUSTOMERS",
      action: "VISUALIZZA TUTTO",
      not_active: "Non Attivo",
      active: "Attivo",
    },
    ekloks_card: {
      title: "EKLOKS",
      action: "VISUALIZZA TUTTO",
      error: "Errore",
      not_connected: "Non Connesso",
      connected: "Connesso",
    },
    installer_card: {
      title: "INSTALLERS",
      action: "VISUALIZZA TUTTO",
      not_active: "Non Attivo",
      active: "Attivo",
    },
    support_card: {
      title: "SUPPORT",
      action: " VIEW ALL",
      not_active: "Not Active",
      active: "Active",
    },
    plant_card: {
      title: "PLANTS",
      action: "VISUALIZZA TUTTO",
    },
    footer: {
      privacy_policy: "Privacy policy",
      cookies_policy: "Cookies policy",
      certification: "Certificazione ISO",
      company_policy: "Politica aziendale",
      condition: "Condizioni di vendita e garanzia",
      sales_contract: "Contratto di vendita EKlok",
      return_policy: "Politica Resi",
      link_privacy_policy: "https://www.ecat.it/privacy-policy/",
      link_cookies_policy: "https://www.ecat.it/cookie/",
      link_certification: "https://www.ecat.it/src/html/doc/9001_Italiano.pdf",
      link_company_policy: "https://www.ecat.it/politica_aziendale/",
      link_condition: "https://www.ecat.it/src/html/doc/condizioni_vendita.pdf",
      link_sales_contract:
        "https://www.ecat.it/src/html/doc/contratto_eklok_ita.pdf",
      link_return_policy:
        "https://www.ecat.it/src/html/doc/return_policy_ita.pdf",
    },
    not_found: {
      error_404: "404: Pagina non trovata.",
      description:
        "You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation",
    },
    heads_list_installers: {
      name: "Nome",
      email: "Email",
      username: "Username",
      country: "Nazione",
      city: "Città",
      last_update: "Ultimo aggiornamento",
      connected: "Connesso",
      alarms: "Allarmi",
      mobile: "Mobile",
      actions: "Azioni",
      connect: "Connetti",
    },
    heads_list_customers: {
      name: "Nome",
      email: "Email",
      username: "Username",
      country: "Country",
      city: "City",
      mobile: "Mobile",
      actions: "Actions",
    },
    heads_list_supports: {
      name: "Nome",
      email: "Email",
      username: "Username",
      country: "Country",
      city: "City",
      mobile: "Mobile",
      actions: "Actions",
    },
    heads_list_ekloks: {
      name: "Nome",
      hw: "HW",
      serial: "Serial",
      HMI: "HMI",
      SW: "SW",
      last_update: "Ultimo aggiornamento",
      connected: "Connesso",
      alarms: "Allarmi",
      actions: "Azioni",
    },
    edit_eklok: {
      title: "Modifica Eklok",
      name: "Nome",
      serial_id: "Serial ID",
      hw_id: "HW ID",
      hmi_version: "HMI Version",
      software_version: "Versione Software",
      model_type: "Tipo di Modello",
      save: "Salva",
    },
    pair_eklok: {
      serial_id: "Serial ID",
      save: "Salva",
      notice: {
        title: "Assicurati di essere loggato sul tuo Eklok prima di procedere",
        login_text: "Login Eklok",
        enter_text: "Inserisci Serial ID",
        confirm_text: "Conferma e attiva",
        confirm_button: "Ok",
      },
    },
    active_eklok: {
      generate_code: "Genera Codice",
      generate_otp_code: "Genera Codice OTP",
    },
    create_eklok: {
      title: "Crea Eklok",
      name: "Nome",
      serial_id: "Serial ID",
      save: "Salva",
    },
    create_support: {
      title: "Crea Nuovo supporto",
      first_name: "Nome",
      last_name: "Cognome",
      email: "Email",
      username: "Username",
      password: "Password",
      confirm_password: "Conferma password",
      telephone_number: "Numero di telefono",
      cellular_number: "Numero di cellulare",
      fax_number: "Numero di fax",
      street: "Via",
      city: "Città",
      cap: "Codice Postale",
      district: "Regione",
      country: "Paese",
      save: "Salva",
      success: "Utente creato con successo",
    },
    create_plant: {
      name: "Nome",
      country: "Paese",
      district: "Provincia",
      city: "Città",
      cap: "Cap",
      street: "Via",
      save: "Salva",
    },
    device_frame: {
      timeout: "Tempo di connessione scaduto",
    },
    mobile_frame: {
      home: {
        favorites: "Preferiti",
        routines: "Routines",
        musics: "Brani",
        musicsSynth: "Brani Synth",
        dialCorrection: "Correggi Quadranti",
        melodies: "MP3",
        assistance: "Assistenza",
        success: "Operazione eseguita con successo",
        stopAll: "Blocca tutti gli eventi",
        details: "Dettagli",
        eklok_name: "Nome eklok:",
        action_type: "Tipo azione:",
        action_name: "Nome azione:",
        action_description: "Descrizione:",
        play_now: "Riproduci ora",
        playing: "In riproduzione",
        seconds: "al termine",
        duration: "Durata:",
        view_all_event: "Visualizza tutti gli eventi",
        running_events: "Eventi in corso",
        no_running_events: "Non ci sono eventi in corso",
        no_action_present: "Non ci sono azioni presenti",
        finished: "Finished",
        blocks_sounds: "Blocca suoni",
        allow_all: "Consenti tutto",
        only_sounds_and_hours: "Solo suoni ore",
        deny_all: "Blocca tutto",
        select_new_configuration: "Seleziona nuova configurazione",
        current_configuration: "Configurazione attuale",
        support_address: "Indirizzo:",
        support_company: "Nome azienda:",
        support_mail: "Email:",
        support_phone: "Telefono:",
        support_website: "Sito web:",
        installer_data: "Dati installatore",
        calendar_event: "Calendario Eventi",
      },
    },
    alarms_eklok: {
      ALARM_USB_INVALID: "Usb non valida",
      ALARM_CPU_HIGH: "Utilizzo CPU",
      ALARM_MEMORY_HIGH: "Utilizzo Memoria",
      ALARM_KBWRUTEDISK_HIGH: "Scrittura disco",
      ALARM_KBREADDISK_HIGH: "Lettura disco",
      ALARM_STORAGEROOT_HIGH: "Scrittura partizione root",
      ALARM_STORAGETMPFS_HIGH: "Scrittura filesystem temporaneo",
      ALARM_SERVICE_EXPIRED: "Manutenzione scaduta",
      ALARM_SW_WD_EXPIRED: "Watchdog scaduto",
      ALARM_BATTERY_REMOVED: "Batteria rimossa",
      ALARM_DIAL_ERROR: "Quadrante in errore",
      ALARM_AUTO_TIME_INVALID: "Orario automatico",
      ERRORE_MODULO_INDIRIZZO: "Errore modulo indirizzo",
      ALARM_BATTERY_FAULT: "Malfunzionamento batteria",
      ALARM_CONNECTION_MODEM_ISSUE:
        "Impossibile connettere automaticamente il modem",
      POWER_DISCONNECTED: "Alimentazione scollegata",
      RTC_INVALID: "RTC non valido",
    },
    edit_eklok_reley: {
      title: "Relé",
      name: "Relé",
      value: "Valore",
      save: "Salva",
    },
    errors: {
      mqtt_action_error_timeout:
        "Si è verificato un errore di comunicazione. Codice errore 60002",
      mqtt_action_no_data: "Si è verificato un errore. Codice errore 60003",
      mqtt_action_wrong_format_data:
        "Si è verificato un errore. Codice errore 60004",
      mqtt_action_error: "Si è verificato un errore. Codice errore 60005",
      user_disabled: 'Account disabilitato. Contatta l\'assistenza.',
      installer_cannot_be_deleted:
        "Operazione non consentita, verifica la sezione Plants",
      customer_cannot_be_deleted: "Operazione non consentita",
      http_400: "Richiesta non valida.",
      http_401: "Credenziali non valide.",
      http_403: "Non hai i permessi per eseguire questa operazione.",
      http_404: "Risorsa non trovata.",
      http_409: "Conflitto con lo stato attuale della risorsa.",
      http_422: "I dati inviati non sono validi.",
      http_429: "Troppe richieste. Riprova tra qualche istante.",
      http_500: "Errore interno del server. Riprova più tardi.",
      http_502: "Il server non è raggiungibile. Riprova più tardi.",
      http_503: "Servizio temporaneamente non disponibile.",
      http_504: "Timeout del server. Riprova più tardi.",
      wrong_password: "La password inserita non è corretta.",
      network: "Impossibile contattare il server. Controlla la connessione.",
      unknown: "Si è verificato un errore imprevisto.",
    },
    statuses: {
      connected: "connesso",
      unconnected: "disconnesso",
      loading: "caricamento...",
    },
    tooltip_titles: {
      refresh: "Aggiorna",
      connect: "Connetti",
      details: "Dettagli",
    },
    details_modal: {
      plant_details: "DETTAGLI IMPIANTO",
      created_by: "Creato da",
      location: "Indirizzo",
      updated_by: "Aggiornato da",
      info: "Info",
      activity: "Attività",
      edit_plant: "Modifica impianto",
      delete_plant: "Elimina impianto",
      plant_user: "Utente",
      plant_email: "Email",
      plant_id: "Plant ID",
      plant_country: "Paese",
      plant_district: "Provincia",
      plant_city: "Città",
      plant_street: "Via",
      plant_cap: "Cap",
      plant_date: "Data",
      device_title: "DETTAGLI DISPOSITIVO",
      module_status: "STATO MODULI",
      edit_eklok: "Modifica Eklok",
      delete_eklok: "Elimina Eklok",
      connect_eklok: "Connetti Eklok",
      generate_code: "Genera codice",
      generate_otp_code: "Genera codice OTP",
      eklok_name: "Nome",
      eklok_hmi_version: "HMI Version",
      eklok_hw_id: "HW ID",
      eklok_serial_id: "Serial ID",
      eklok_middleware_version: "Middleware version",
      eklok_software_version: "Software version",
      eklok_model_type: "Modello",
      activity_connected: "Stato connessione",
      modules_tooltip_name: "NOME",
      modules_tooltip_percentage: "PERCENTUALE UTILIZZO",
      modules_tooltip_hits: "N.COLPI",
      modules_tooltip_usage_time: "TEMPO UTILIZZO",
      modules_tooltip_type: "TIPO",
      alarms_title: "Allarmi",
      alarms_code: "Codice",
      alarms_status: "Stato",
      alarms_time: "Data",
      alarms_status_active: "ATTIVO",
      alarms_status_inactive: "INATTIVO",
    },
    create_plant_modal: {
      title: "Crea Impianto",
      step_create_plant: "Crea Impianto",
      step_create_eklok: "Crea Eklok",
      step_gen_active_key: "Genera Activation key",
    },
    table: {
      search: "Cerca",
      rows_per_page: "Elementi per pagina",
      prev_page: "Pagina precedente",
      next_page: "Pagina successiva",
    },
    calendar_event: {
      select_date: "Scegli una Data:",
      add_new_event: "Nuovo Evento",
      no_events_in_list: "Nessun evento disponibile",
      confirm_dialog_title: "Conferma cancellazione",
      confirm_dialog_message: "Vuoi procedere con la cancellazione?",
      confirm_button: "Conferma",
      cancel_button: "Annulla",
    },
    calendar_event_item: {
      delete: "Elimina",
      from: "Da",
      to: "A",
    },
    create_calendar_event: {
      name_label: "Nome*",
      description_label: "Descrizione*",
      date_and_time_label: "Data e Ora*",
      actions_label: "Azioni*",
      select_actions: "Seleziona azioni",
      add_event: "Aggiungi Evento",
      required_field: "Campo obbligatorio",
    },
    action_type: {
      MUSICS: "BRANI",
      MELODIES: "MP3",
      MUSICS_SYNTH: "BRANI SYNTH",
      ACTIONS: "ROUTINES",
    },
  },
};

export default it;
